import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Signup.css';
import iconBack from '../../assets/images/icon-back.svg';

const PhoneInput: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as Record<string, any>;
  const [phone, setPhone] = useState('');

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setPhone(value);
  };

  const handleNext = () => {
    if (phone.length >= 10) {
      navigate('/signup/verification');
    }
  };

  const handleSkip = () => {
    navigate('/signup/gender', { state });
  };

  const handleBack = () => {
    navigate('/login');
  };

  return (
    <div className="signup-container">
      <div className="signup-header">
        <button className="back-button" onClick={handleBack}>
          <img src={iconBack} alt="뒤로가기" />
        </button>
      </div>

      <div className="signup-content">
        <div className="signup-inner">
          <div className="signup-form">
            <div className="signup-title-section">
              <h1 className="signup-title">
                휴대폰번호를
                <br />
                입력해 주세요.
              </h1>
              <p className="signup-subtitle">
                입력하신 번호는 매장에게 공개되지 않아요.
              </p>
            </div>

            <div className="input-section">
              <input
                type="tel"
                className="signup-input"
                placeholder="01012345678"
                value={phone}
                onChange={handlePhoneChange}
                maxLength={11}
              />
            </div>
          </div>

          <div className="signup-footer">
            <div className="help-text-section">
              <p className="help-text">휴대폰번호가 변경되셨나요?</p>
              <p className="link-text">이메일로 불러오기</p>
            </div>

            <button
              className={`signup-btn ${phone.length >= 10 ? 'active' : ''}`}
              onClick={handleNext}
              disabled={phone.length < 10}
            >
              다음
            </button>
            <p className="link-text" style={{ textAlign: 'center' }} onClick={handleSkip}>
              건너뛰기
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhoneInput;
